import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { InstallmentsService } from '@app/financial/services';
import { InitAdminService } from '@app/admin/services/init-admin.service';
import { TypeResponse } from '@app/shared/enum/TypeResponse';
import { MessageService } from '@app/shared/services/message.service';

@Component({ templateUrl: 'installments-list.component.html', providers: [DatePipe] })
export class InstallmentsListComponent implements OnInit {

  public installments: any = [];
  public showTable: boolean;
  public dateNow = new Date();
  dataResult: boolean = false;
  public returnMessage = '';

  public columns: Array<any> = [
    { title: "Código", name: "id", sort: "asc", className: "text-center" },
    { title: "Número", name: "instalmentNumber", sort: "asc", className: "text-center" },
    {
      title: "Emissão",
      name: "issuance",
      sort: "asc",
      className: "text-center text-primary datetime"
    },
    {
      title: "Vencimento",
      name: "due",
      sort: "asc",
      className: "text-center text-primary datetime"
    },
    { title: "Valor", name: "value", sort: "asc" },
    { title: "Desconto", name: "discount", sort: "asc" },
    { title: "Líquido", name: "netValue", sort: "asc" },
    {
      title: "Criado em",
      name: "createdOn",
      sort: "asc",
      className: "text-center text-primary datetime"
    },
    {
      title: "Modificado em",
      name: "updatedOn",
      sort: "asc",
      className: "text-center text-primary datetime"
    }
  ];
  
  constructor(
    private installmentsService: InstallmentsService,
    private initAdmin: InitAdminService,
    private loading: MessageService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.initAdmin.setConfigPage();
    this.dataResult = false;
    this.loadBanks();
  }

  loadBanks() {
    this.loading.showLoading();
    this.installmentsService.getAll().subscribe((response: any) => {
      if (response.typeResponse == TypeResponse.Success) {
        this.installments = response.data;
        this.showTable = true;
        this.returnMessage = '';
      } else {
        this.returnMessage = response.message;
        this.showTable = false;
      }
      this.loading.hideLoading();
    }, (error: any) => {
      this.loading.hideLoading();
      this.showTable = false;
      this.returnMessage = 'Erro ao carregar os dados das parcelas.';
    });
  }

  delete(id: any): void {
    // Swal({
    //   title: "Deseja realmente excluir este registro?",
    //   text: "Ao clicar ok, este será excluído permanentemente!",
    //   type: 'warning',
    //   showConfirmButton: true,
    //   showCancelButton: true     
    // })
    // .then((willDelete)=> {
    //   if (willDelete.value === true) {
    //     // To delete
    //   }
    // });
  }

  edit(row:any): void {
    this.loading.showLoading();
    this.router.navigate(['/financial/installments', { id: row.id }]);
  }
}
